import useGlobalState from 'components/App/globalstate/useGlobalState';

const useInviteId = () => {
  const { inviteId, setInviteId } = useGlobalState();
  return { inviteId, setInviteId };
};

export default useInviteId;
